import "./_LineUp.scss";
import { Link } from "react-router-dom";
function LineUp({ lineUp }) {
	return (
		<section className="line_up">
			<div className="lineup">
				{lineUp.map((m, idx) => {
					return (
						<p key={idx}>
							{m.name}
							<span>&#183;</span>
						</p>
					);
				})}
				<a className="cta" href="https://foofestapp.netlify.app/" target="_blank">
					To Festival App
					<span>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							fill="currentColor"
							className="bi bi-arrow-up-right"
							viewBox="0 0 16 16"
						>
							<path
								fillRule="evenodd"
								d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"
							/>
						</svg>
					</span>
				</a>
			</div>
		</section>
	);
}

export default LineUp;
